import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Wrapper = styled.div`
  background-color: ${myPalette.white.main};
  border-radius: 12px;
  box-shadow: 0 0 5px 0 #0015461a;
  padding: 20px;
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  gap: 16px;
`
